module.exports = __webpack_public_path__ + "img/NATIONALID.bf9b560c.png";